import { render, staticRenderFns } from "./entityDialogView.vue?vue&type=template&id=53d467ab&scoped=true&"
import script from "./entityDialogView.vue?vue&type=script&lang=js&"
export * from "./entityDialogView.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogView.vue?vue&type=style&index=0&id=53d467ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d467ab",
  null
  
)

export default component.exports